/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect } from 'react';
import {
  Button, TextField,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import elearningDetailsServices from '../../redux/services/elearningDetailsServices';
import { toastError, toastSuccess } from '../../redux/actions/alertActions';

const ClientBill = ({ examDataLv1, clientBillProps }) => {
  const [clientBill, setClientBill] = useState('');

  useEffect(() => {
    setClientBill(clientBillProps);
  }, []);

  const handleClientBill = (e) => {
    setClientBill(e.target.value);
  };

  const saveClientBill = () => {
    elearningDetailsServices.updateElearningOption(examDataLv1.examId, { clientBill })
      .then((res) => {
        toastSuccess('Date facturation client mise à jour.');
      })
      .catch((err) => toastError('Echec de la mise à jour.'));
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <TextField
        value={clientBill}
        variant="outlined"
        multiline
        rows={0}
        onChange={handleClientBill}
        inputProps={{
          style: {
            color: '#6b6b6b',
            fontSize: '13px',
          },
        }}
      />
      <Button
        variant="outlined"
        color="primary"
        size="small"
        style={{
          marginTop: '10px',
          fontSize: '10px',
          alignSelf: 'flex-end',
        }}
        onClick={saveClientBill}
      >
        Save
      </Button>
    </div>
  );
};

ClientBill.propTypes = {
  examDataLv1: PropTypes.object.isRequired,
};

export default ClientBill;
